// Rendimiento del mega menu.
// El JS de la seccion header-nazalea precargaba TODAS las fotos del desplegable
// nada mas cargar la pagina (requestIdleCallback -> loading="eager"). Eso son
// ~12 descargas que la mayoria de visitas nunca llega a ver.
//
// Este script se adelanta: parchea requestIdleCallback y setTimeout para anular
// esa precarga automatica concreta, y en su lugar precarga las fotos solo cuando
// hay intencion real de abrir el menu (raton sobre la cabecera o toque en la
// hamburguesa). El arreglo original del bug de tarjetas en blanco se mantiene,
// porque abrir() sigue llamando a su propia precarga.
(function () {
  var YA = false;

  function esPrecarga(fn) {
    try {
      return typeof fn === 'function' && /tarjeta-img/.test(Function.prototype.toString.call(fn));
    } catch (e) { return false; }
  }

  var ric = window.requestIdleCallback;
  if (typeof ric === 'function') {
    window.requestIdleCallback = function (fn, opts) {
      if (esPrecarga(fn)) { return 0; }
      return ric.call(window, fn, opts);
    };
  }

  var st = window.setTimeout;
  window.setTimeout = function (fn, ms) {
    if (ms === 2500 && esPrecarga(fn)) { return 0; }
    return st.apply(window, arguments);
  };

  function precargar() {
    if (YA) { return; }
    YA = true;
    var imgs = document.querySelectorAll('.header-nazalea__tarjeta-img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].setAttribute('loading', 'eager'); }
  }

  function enganchar() {
    var cab = document.querySelector('[data-header-nazalea]');
    if (!cab) { return false; }
    cab.addEventListener('mouseenter', precargar, { once: true, passive: true });
    var ham = cab.querySelector('[data-abrir-menu]');
    if (ham) { ham.addEventListener('pointerdown', precargar, { once: true, passive: true }); }
    var prod = cab.querySelector('[data-productos]');
    if (prod) { prod.addEventListener('mouseenter', precargar, { once: true, passive: true }); }
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else if (!enganchar()) {
    setTimeout(enganchar, 300);
  }
})();
